<div *ngIf="model">
    <div class="btw-row">
        <div class="btw-col-12">
            <btw-card [title]="model.name">
                <span>{{model.description}}</span>
            </btw-card>
        </div>
    </div>

    <div class="subtitle">
        Model Performance
    </div>

    <div *ngIf="modelPerformanceDataSource && modelPerformanceDataSource.length">
        <table style="width: 100%;">
            <thead>
                <tr>
                    <th><b>Id</b></th>
                    <th><b>Metric name</b></th>
                    <th><b>Metric value</b></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let dataItem of modelPerformanceDataSource">
                    <td>{{dataItem.id}}</td>
                    <td>{{dataItem.metricName}}</td>
                    <td>{{dataItem.metricValue}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="subtitle">
        Model Results
    </div>

    <div *ngIf="modelResultDataSource && modelResultDataSource.length">
        <table style="width: 100%;">
            <thead>
                <tr> 
                    <!-- TODO: Dirty fix; add model type to display table columns depending on whether the model is of classification or predictive type-->
                    <th><b>Analysis date</b></th>
                    <!-- <th><b>Prediction</b></th> -->
                    <th *ngIf="modelResultDataSource[0].modelId === 1"><b>Prediction</b></th>
                    <th *ngIf="modelResultDataSource[0].modelId === 1"><b>Probability of default</b></th>
                    <th *ngIf="modelResultDataSource[0].modelId === 2"><b>Cluster</b></th>
                    <th *ngIf="modelResultDataSource[0].modelId === 2"><b>Cluster Description</b></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let dataItem of modelResultDataSource">
                    <td>{{ dataItem.predictionDate | date:'yyyy/MM/dd' }}</td>
                    <td *ngIf="dataItem.modelId === 1">{{ dataItem.prediction === 1 ? 'Blockade' : 'Non-blockade' }}</td>
                    <!-- <td>{{ dataItem.prediction === 1 ? 'Blockade' : 'Non-blockade' }}</td> -->
                    <!-- <td>{{dataItem.prediction}}</td> --> 
                    <td *ngIf="dataItem.modelId === 1">{{dataItem.probabilityOfDefault}}</td>
                    <td *ngIf="dataItem.modelId === 2">{{dataItem.cluster}}</td>
                    <td *ngIf="dataItem.modelId === 2">{{dataItem.clusterDescription}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div *ngIf="!model">
    <p>Loading model details...</p>
</div>